const rankingData = [
  {
    rank: 1,
    title: '某顶流男星深夜密会神秘女子，酒店同住三天',
    heat: '1256w',
    tag: '爆',
    trend: '↗ 23%',
  },
  {
    rank: 2,
    title: '千万粉丝网红人设崩塌，品牌方集体解约',
    heat: '980w',
    tag: '热',
    trend: '↗ 18%',
  },
  {
    rank: 3,
    title: '综艺录制现场嘉宾罢录，节目组紧急公关',
    heat: '756w',
    tag: '热',
    trend: '↗ 12%',
  },
  {
    rank: 4,
    title: '知名歌手新专辑被指抄袭，乐评人列出实锤',
    heat: '543w',
    tag: '新',
    trend: '↗ 35%',
  },
  {
    rank: 5,
    title: '电影剧组导演主演片场对骂，视频外流',
    heat: '487w',
    tag: '热',
    trend: '↗ 8%',
  },
  {
    rank: 6,
    title: '某夫妻档被曝分居，财产分割方案曝光',
    heat: '432w',
    tag: '新',
    trend: '↗ 42%',
  },
];

const rankMedalColors: Record<number, string> = {
  1: 'bg-accent-500 text-background-50',
  2: 'bg-secondary-400 text-background-50',
  3: 'bg-secondary-300 text-background-50',
};

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            黑料榜单
          </h2>
          <p className="mt-2 text-sm text-foreground-500">本周最火爆的吃瓜内容排行榜</p>
        </div>

        <div className="max-w-3xl mx-auto">
          {rankingData.map((item) => (
            <div
              key={item.rank}
              className="flex items-center gap-4 p-4 border-b border-background-200/60 last:border-b-0 cursor-pointer hover:bg-background-50 transition-colors group"
            >
              <span
                className={`w-8 h-8 flex items-center justify-center rounded-full text-sm font-bold flex-shrink-0 ${
                  rankMedalColors[item.rank] || 'bg-background-200 text-foreground-600'
                }`}
              >
                {item.rank}
              </span>
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium text-foreground-800 group-hover:text-primary-500 transition-colors truncate">
                  {item.title}
                </p>
              </div>
              <span className="text-xs px-1.5 py-0.5 rounded bg-primary-100 text-primary-600 font-medium whitespace-nowrap">
                {item.tag}
              </span>
              <span className="text-xs text-foreground-400 whitespace-nowrap">
                <i className="ri-fire-line mr-1 text-accent-500"></i>{item.heat}
              </span>
              <span className="text-xs text-accent-500 whitespace-nowrap hidden sm:inline">
                {item.trend}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}